<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="utf-8">
  <meta content="width=device-width, initial-scale=1.0" name="viewport">

  <title>SAION - Tecnología gubernamental</title>
  <meta content="" name="description">
  <meta content="" name="keywords">

  <!-- Favicons -->
  <link href="/assets/img/favicon.png" rel="icon">
  <link href="/assets/img/apple-touch-icon.png" rel="apple-touch-icon">

  <!-- Google Fonts -->
  <link href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Roboto:300,300i,400,400i,500,500i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i" rel="stylesheet">

  <!-- Vendor CSS Files -->
  <link href="/assets/vendor/animate.css/animate.min.css" rel="stylesheet">
  <link href="/assets/vendor/aos/aos.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap/css/bootstrap.min.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap-icons/bootstrap-icons.css" rel="stylesheet">
  <link href="/assets/vendor/boxicons/css/boxicons.min.css" rel="stylesheet">
  <link href="/assets/vendor/glightbox/css/glightbox.min.css" rel="stylesheet">
  <link href="/assets/vendor/remixicon/remixicon.css" rel="stylesheet">
  <link href="/assets/vendor/swiper/swiper-bundle.min.css" rel="stylesheet">

  <!-- Template Main CSS File -->
  <link href="/assets/css/style.css" rel="stylesheet">

  <!-- =======================================================
  * Template Name: Company - v4.7.0
  * Template URL: https://bootstrapmade.com/company-free-html-bootstrap-template/
  * Author: BootstrapMade.com
  * License: https://bootstrapmade.com/license/
  ======================================================== -->
</head>

<body>

  <!-- ======= Header ======= -->


  <!-- ======= Hero Section ======= -->




  <main id="main">














<!--
   <section id="portfolio" class="portfolio">
      <div class="container">

        <div class="row" data-aos="fade-up">
          <div class="col-lg-12 d-flex justify-content-center">
            <ul id="portfolio-flters">
              <li data-filter="*" class="filter-active">Todas</li>
              <li data-filter=".filter-app">Parquímetros</li>
              <li data-filter=".filter-card">Guardería</li>
              <li data-filter=".filter-web">Pagos Online</li>
            </ul>
          </div>
        </div>

        <div class="row portfolio-container" data-aos="fade-up">

          <div class="col-lg-4 col-md-6 portfolio-item filter-app">
            <img height="300" width="200" src="/assets/img/parquimetros/pago.png" class="img-fluid" alt="">
            <div height="300" width="200" class="portfolio-info">
              <h4>Mas detalles</h4>
              <p></p>
              <a href="/assets/img/parquimetros/pago.png" data-gallery="portfolioGallery" target="_blank" class="portfolio-lightbox preview-link" title="App 1"><i class="bx bx-plus"></i></a>
              <a href="https://play.google.com/store/apps/details?id=com.Accendo.Saion&hl=es_MX" target="_blank" class="details-link" title="More Details"><i class="bx bx-link"></i></a>
            </div>
          </div>


          <div class="col-lg-4 col-md-6 portfolio-item filter-app">
            <img src="/assets/img/parquimetros/mapa.png" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>Mas detalles</h4>
              <p></p>
              <a href="/assets/img/parquimetros/pago.png" data-gallery="portfolioGallery" target="_blank" class="portfolio-lightbox preview-link" title="App 1"><i class="bx bx-plus"></i></a>
              <a href="https://play.google.com/store/apps/details?id=com.Accendo.Saion&hl=es_MX" target="_blank" class="details-link" title="More Details"><i class="bx bx-link"></i></a>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 portfolio-item filter-app">
            <img  src="/assets/img/parquimetros/vehiculos.png" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>Mas detalles</h4>
              <p></p>
              <a href="/assets/img/parquimetros/pago.png" data-gallery="portfolioGallery" target="_blank" class="portfolio-lightbox preview-link" title="App 1"><i class="bx bx-plus"></i></a>
              <a href="https://play.google.com/store/apps/details?id=com.Accendo.Saion&hl=es_MX" target="_blank" class="details-link" title="More Details"><i class="bx bx-link"></i></a>

            </div>
          </div>
          <div class="col-lg-4 col-md-6 portfolio-item filter-app">
            <img  src="/assets/img/parquimetros/saldo.png" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>Mas detalles</h4>
              <p></p>
              <a href="/assets/img/parquimetros/pago.png" data-gallery="portfolioGallery" target="_blank" class="portfolio-lightbox preview-link" title="App 1"><i class="bx bx-plus"></i></a>
              <a href="https://play.google.com/store/apps/details?id=com.Accendo.Saion&hl=es_MX" target="_blank" class="details-link" title="More Details"><i class="bx bx-link"></i></a>
            </div>
          </div>




          <div class="col-lg-4 col-md-6 portfolio-item filter-web">
            <img src="/assets/img/parquimetros/mapa.png" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4></h4>
              <p></p>
              <a href="/assets/img/portfolio/portfolio-2.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox preview-link" title="Web 3"><i class="bx bx-plus"></i></a>
              <a href="portfolio-details.html" class="details-link" title="More Details"><i class="bx bx-link"></i></a>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 portfolio-item filter-web">
            <img src="/assets/img/portfolio/portfolio-5.jpg" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>Web 2</h4>
              <p>Web</p>
              <a href="/assets/img/portfolio/portfolio-5.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox preview-link" title="Web 2"><i class="bx bx-plus"></i></a>
              <a href="portfolio-details.html" class="details-link" title="More Details"><i class="bx bx-link"></i></a>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 portfolio-item filter-web">
            <img src="/assets/img/portfolio/portfolio-9.jpg" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>Web 3</h4>
              <p>Web</p>
              <a href="/assets/img/portfolio/portfolio-9.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox preview-link" title="Web 3"><i class="bx bx-plus"></i></a>
              <a href="portfolio-details.html" class="details-link" title="More Details"><i class="bx bx-link"></i></a>
            </div>
          </div>






          <div class="col-lg-4 col-md-6 portfolio-item filter-card">
            <img src="/assets/img/portfolio/portfolio-7.jpg" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>Card 1</h4>
              <p>Card</p>
              <a href="/assets/img/portfolio/portfolio-7.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox preview-link" title="Card 1"><i class="bx bx-plus"></i></a>
              <a href="portfolio-details.html" class="details-link" title="More Details"><i class="bx bx-link"></i></a>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 portfolio-item filter-card">
            <img src="/assets/img/portfolio/portfolio-8.jpg" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>Card 3</h4>
              <p>Card</p>
              <a href="/assets/img/portfolio/portfolio-8.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox preview-link" title="Card 3"><i class="bx bx-plus"></i></a>
              <a href="portfolio-details.html" class="details-link" title="More Details"><i class="bx bx-link"></i></a>
            </div>
          </div>


          <div class="col-lg-4 col-md-6 portfolio-item filter-card">
            <img src="/assets/img/portfolio/portfolio-4.jpg" class="img-fluid" alt="">
            <div class="portfolio-info">
              <h4>Card 2</h4>
              <p>Card</p>
              <a href="/assets/img/portfolio/portfolio-4.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox preview-link" title="Card 2"><i class="bx bx-plus"></i></a>
              <a href="portfolio-details.html" class="details-link" title="More Details"><i class="bx bx-link"></i></a>
            </div>
          </div>

       </div>

      </div>
    </section>End Portfolio Section
 -->


    <!-- <section id="team" class="team section-bg" style="background-color: rgb(255, 255, 255);">
      <div class="container">

        <div class="section-title" data-aos="fade-up" style="text-align: center;">


        </div>

        <div class="row">



          <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
            <div class="member" data-aos="fade-up" data-aos-delay="200">
              <div class="member-img">

              </div>

            </div>
          </div>

          <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
            <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FGobiernoMunicipalTol&tabs=timeline&width=400&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="400" height="500" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
          </div>

          <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
            <div class="member" data-aos="fade-up" data-aos-delay="100">
              <div class="member-img">
                <iframe width="400" height="396" src="https://www.youtube.com/embed/eltdnUwB4Ew?si=LGdc4HCJ81D-ohD2" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>

            </div>
          </div>

          <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
            <div class="member" data-aos="fade-up" data-aos-delay="100">
              <div class="member-img">

              </div>

            </div>
          </div>



        </div>

      </div>
    </section> -->



    <!-- ======= About Us Section ======= -->
    <section  style="background-color: rgb(255, 255, 255);">
      <div class="container" data-aos="fade-up" style="background-color: rgb(255, 255, 255);">

        <div class="row content">


          <div class="col-lg-2 pt-4 pt-lg-0"></div>
          <div class="col-lg-4 pt-4 pt-lg-0" data-aos="fade-right">
            <h2 style="color: #efa512;"> Visita nuestra página de facebook</h2>
            <h3 style="text-align: justify;"></h3>
            <br>
            <label>  </label>
            <br>
            <label>  Administración 2024-2027 </label>
          </div>
          <div class="col-lg-4 pt-4 pt-lg-0" data-aos="fade-left">
            <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fprofile.php%3Fid%3D61583546307903%26sk%3Dabout&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
             width="340" height="500" style="border:none;overflow:hidden" scrolling="no" frameborder="0"
             allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>

          </div>

          <div class="col-lg-2 pt-4 pt-lg-0"></div>
        </div>

      </div>
    </section><!-- End About Us Section -->




    <section class="container" style="margin-top: -3vh;">
      <div class="container py-5">
        <div class="row text-center py-3">
          <div class="col-lg-6 m-auto">
            <h1 class="h1" style="color: #d86c08; font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;">Noticias del Municipio</h1>
<hr>
            <p>
              Informate acerca de las novedades que ocurren en el municipio
            </p>


          </div>
        </div>



        <div class="row" >
          <div class="col-12 col-md-4 mb-3" *ngFor="let noticia of data">


            <div class="card" style="width: 410px;height: 220px; border-radius: 1vh; " id="cardh" data-aos="fade-up">
              <div class="row">
                <div class="col-5">
                  <a href="admin/ver-noticia/{{noticia.ID}}">
                    <img [src]="noticia.ENLACE" height="160" width="300" style="border-radius: 25vh; margin-top: 2vh;margin-bottom: 2vh;margin-left: 1vh;" class="card-img-top" alt="...">
                  </a>
                </div>



                <div class="col-7">
                  <div class="card-body">

                    <a href="admin/ver-noticia/{{noticia.ID}}" style="text-align: center; font-weight: bold;color: #d86c08; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;">{{noticia.ENCABEZADO}}</a>
                    <p class="card-text">

                    </p>
                    <p class="text-muted" style="font-weight: bold;">{{noticia.FECHA}}</p>
                  </div>

                </div>


              </div>






            </div>
          </div>







        </div>







      </div>
    </section>





  </main>

<hr>
  <a href="#" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>

  <!-- Vendor JS Files -->
  <script src="/assets/vendor/aos/aos.js"></script>
  <script src="/assets/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
  <script src="/assets/vendor/glightbox/js/glightbox.min.js"></script>
  <script src="/assets/vendor/isotope-layout/isotope.pkgd.min.js"></script>
  <script src="/assets/vendor/swiper/swiper-bundle.min.js"></script>
  <script src="/assets/vendor/waypoints/noframework.waypoints.js"></script>
  <script src="/assets/vendor/php-email-form/validate.js"></script>

  <!-- Template Main JS File -->
  <script src="/assets/js/main.js"></script>

</body>

</html>
